import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CourierService } from 'src/app/shared/services/courier.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-courier-detail',
  templateUrl: './courier-detail.component.html',
  styleUrls: ['./courier-detail.component.css']
})
export class CourierDetailComponent implements OnInit {

  form: FormGroup;
  description:string;
  dialogData :any;

  constructor(public service: CourierService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialogRef: MatDialogRef<CourierDetailComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.dialogData = data;
   }

  ngOnInit() {
  }

  counter(i: number) {
    return new Array(i);
  }

  onClose()
  {
    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create Customer");
    if (this.service.form.valid) {

      if (!this.service.form.get('id').value){
        this.service.insertData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submitted successfully", "Courier Create");
            this.gnotify.showSnackBar('Courier Create', 'Submitted successfully', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
               console.log(err);
             ////this.toastr.error("Failed to Submit", "Courier Create");
             this.gnotify.showSnackBar('Courier Create', 'Failed to Submit', "error");
             return false;
          }
          );
      }
      else{
        this.service.updateData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submitted successfully", "Courier Modify");
            this.gnotify.showSnackBar('Courier Modify', 'Submitted successfully', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Courier Modify");
            this.gnotify.showSnackBar('Courier Modify', 'Failed to Submit', "error");
            return false;
          }
          );

      }

    }
    return true;
  }

}
